import { ApiService, Model, UserModel } from '@kaiser-software/chassis-core';

export class CommentModel extends Model {

    public id: number;
    public comment: string;
    public user_id: number;
    public commentable_id: number;
    public commentable_type: string;

    public constructor(data?: Object, _service?: ApiService) {

        super(data, _service);

        this.boot(data);

    }

    // public relationsUser() {
    //     return this.hasOne(UserModel, 'user');
    // }
}



// WEBPACK FOOTER //
// ./libs/chassis-comments/src/app/models/comment.model.ts